// import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
// import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  // {
  //   link: 'https://github.com/enkogit',
  //   label: 'Github',
  //   icon: faGithub,
  // },
  {
    link: 'https://www.linkedin.com/in/enko',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  // {
  //   link: 'https://twitter.com/v_enko',
  //   label: 'Twitter',
  //   icon: faTwitter,
  // },
  // {
  //   link: 'https://www.youtube.com/@northforrest',
  //   label: 'Youtube',
  //   icon: faYoutube,
  // },
];

export default data;
